import React from 'react';
import { Text } from '@fluentui/react';
import { MathToFixed } from './Utils';
import { UserRegistrationPeriod } from '../api/generated/data-contracts';
import { DisplayCell } from './WeekOverview/DisplayCell';
import { PeriodDay } from '../types/PeriodDay';

interface PlannedCellProps {
    time: UserRegistrationPeriod;
    periodDays?: PeriodDay[];
    useDisplayCell?: boolean;
}

/**
 * Component for rendering the planned column.
 * If there is remaining work AND actuals, calculate planned work (actualWork + remainingWork).
 * Otherwise, show the plannedWork value from the time variable.
 */
export const PlannedCell: React.FC<PlannedCellProps> = ({ time, periodDays, useDisplayCell = false }) => {
    const actualWork = time.actualWork || 0;
    const remainingWork = time.remainingWork || 0;
    const plannedWork = time.plannedWork || 0;

    // If there is remaining work AND actuals, calculate planned work
    const hasActualWork = actualWork > 0;
    const hasRemainingWork = remainingWork > 0;

    const plannedValue = hasActualWork || hasRemainingWork ? actualWork + remainingWork : plannedWork;

    // If using DisplayCell, let it handle the zero logic
    if (useDisplayCell && periodDays) {
        return <DisplayCell value={plannedValue} periodDays={periodDays} />;
    }

    // If the value is zero or less, show nothing
    if (plannedValue <= 0) {
        return null;
    }

    return (
        <Text className="cellInner parCellInner" as="div">
            {MathToFixed(plannedValue, 2)}
        </Text>
    );
};
